export const EDIT_LIST_MODULE_ID = 'edit-list-module';
export const EDIT_LIST_MODULE = () => import('@capital-access/lists/actions').then(m => m.EditListModule);
